/**
 * Curaden Base – core front-end behaviour (always loaded, no dependencies).
 * Heavy libraries live in their own bundles (swiper.js, fancybox.js, lottie.js).
 */
import { initNavigation, initDropdown, initAccordion, initHashScroll } from './modules/navigation';
import { initPopup } from './modules/popup';
import { initSales } from './modules/sales';
import { initCareers } from './modules/careers';
import { initShopLinks } from './modules/shop';
import { initMaps } from './modules/map';
import { initVideoHeroes } from './modules/video-hero';

const config = window.curadenBase || {};

const ready = ( fn ) =>
	document.readyState === 'loading' ? document.addEventListener( 'DOMContentLoaded', fn ) : fn();

ready( () => {
	initNavigation();
	initDropdown();
	initAccordion();
	initHashScroll( config.scrollOffset ?? 72 );
	initPopup();
	initSales();
	initCareers();
	initShopLinks( config.shopEndpoint );
	initMaps();
	initVideoHeroes();
} );
